module.exports = __webpack_public_path__ + "img/nathalie_de_loeaper_pratique_shiatsu-mobile.2dab3ec2.webp";